import { create } from 'zustand';

const SIDEBAR_KEY = 'sidebar-collapsed';
const THEME_KEY = 'theme';

type Theme = 'light' | 'dark';

function readSidebarCollapsed(): boolean {
	if (typeof window === 'undefined') return false;
	return localStorage.getItem(SIDEBAR_KEY) === 'true';
}

function readTheme(): Theme {
	if (typeof window === 'undefined') return 'dark';
	return localStorage.getItem(THEME_KEY) === 'light' ? 'light' : 'dark';
}

function applyTheme(theme: Theme) {
	if (typeof document === 'undefined') return;
	document.documentElement.classList.toggle('light', theme === 'light');
}

interface UIStore {
	sidebarCollapsed: boolean;
	theme: Theme;
	activeModal: string | null;
	toggleSidebar: () => void;
	setSidebarCollapsed: (collapsed: boolean) => void;
	toggleTheme: () => void;
	openModal: (id: string) => void;
	closeModal: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
	sidebarCollapsed: readSidebarCollapsed(),
	theme: readTheme(),
	activeModal: null,
	toggleSidebar: () =>
		set((s) => {
			const next = !s.sidebarCollapsed;
			localStorage.setItem(SIDEBAR_KEY, String(next));
			return { sidebarCollapsed: next };
		}),
	setSidebarCollapsed: (collapsed) => {
		localStorage.setItem(SIDEBAR_KEY, String(collapsed));
		set({ sidebarCollapsed: collapsed });
	},
	toggleTheme: () =>
		set((s) => {
			const next: Theme = s.theme === 'light' ? 'dark' : 'light';
			localStorage.setItem(THEME_KEY, next);
			applyTheme(next);
			return { theme: next };
		}),
	openModal: (id) => set({ activeModal: id }),
	closeModal: () => set({ activeModal: null }),
}));
